import { Controller } from "stimulus";

import useFocusTrap from "../../composables/use_focus_trap";

export default class extends Controller {
  static targets = ["discardButton", "saveButton"];

  static values = {
    form: String,
    redirect: String,
  };

  connect() {
    useFocusTrap(this);

    this.element.focus();
  }

  cancelFocusTrap() {
    this.modalElement.modal("hide");
  }

  cancel() {
    this.redirectElement.value = "";
  }

  show(event) {
    // Resolve to the nearest anchor in case the event target is a child node (icon/span). Fall back to "" so we
    // never assign undefined, which the DOM would coerce to the string "undefined" and post as a bogus redirect.
    const href = event.target.closest?.("a[href]")?.href ?? event.target.href ?? "";

    this.redirectElement.value = href;
    this.discardButtonTarget.href = href;

    this.modalElement.modal("show");
  }

  submit() {
    this.formElement.submit();
  }

  get formElement() {
    return document.querySelector(this.formValue);
  }

  get modalElement() {
    return $(this.element);
  }

  get redirectElement() {
    return this.formElement.querySelector(this.redirectValue);
  }
}
